import { render, staticRenderFns } from "./App-Settings.vue?vue&type=template&id=1468fabc&"
import script from "./App-Settings.vue?vue&type=script&lang=js&"
export * from "./App-Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports